import { Component, OnInit, OnDestroy } from '@angular/core';
import { SharedDataService } from './service/shared-service/shared-data.service';
import { takeUntil } from 'rxjs/operators';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';
import { PageReloadService } from './service/page-reload/page-reload.service';
import { VoiceAgentService } from './service/voice-assistance/voice-agent.service';
import { environment } from 'src/environments/environment';
import { AuthService } from './service/auth-service/auth.service';
import { FireworksService } from './service/fireworks-service/fireworks.service';
import { AutoLogoutService } from './service/auto-logout-service/auto-logout.service';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit, OnDestroy {
  isLoggedIn = false;
  user: any;
  timeoutId;

  constructor(
    private sharedDataService: SharedDataService,
    private reloadService: PageReloadService,
    private voiceAgentService: VoiceAgentService,
    private authService: AuthService,
    private fireworksService: FireworksService,
    private autoLogoutService: AutoLogoutService
  ) {
  }

  ngOnInit() {
    this.autoLogoutService.init();
    this.reloadService.startReloading(12 * 60); // Reload every 24 mins
    this.getUserDetails();
  }

  getUserDetails() {
    this.sharedDataService
      .getUser()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(user => {
        if (user) {
          this.user = user;
          this.isLoggedIn = true;
          
          if (this.user.hasOwnProperty('isAllowFireworks') && this.user.isAllowFireworks) {
            this.fireworksService.applyFireworks();
          } else {
            this.fireworksService.stopFireworks();
          }

          this.timeoutId = setTimeout(() => {
            if (this.user.isAllowVoiceAssistance) {
              const token = this.authService.getToken('token');
              const payload = {
                isallowwidget: this.user.isAllowVoiceAssistance,
                credentials: {
                  webhookUrl: environment.baseUrl,
                  webhookToken: 'JWT ' + token,
                  defaultTimezone: this.user.timeZone,
                  company: this.user && this.user.company ? this.user.company._id : this.user._id
                }
              }
              this.voiceAgentService.init(payload);
            } else {
              this.voiceAgentService.destroy();
            }
          }, 2000);

        } else {
          this.voiceAgentService.destroy();
          this.fireworksService.stopFireworks();
          this.isLoggedIn = false;
        }
      });
  }

  ngOnDestroy(): void {

    if (this.timeoutId) {
        clearTimeout(this.timeoutId);
      }
  }

}




